import React, { Component } from "react"

class ClassC extends Component {

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.props.detalhes)
        const errors = Object.assign({}, this.props.errors)

        detalhes[field] = value
    
        if(field in errors) {
            delete errors[field]
            this.props.setErrors(errors)
        }
        
        this.props.setDetalhes(detalhes)
    }
    

    render() {
        const { detalhes, errors, isTemplate } = this.props

        return(
            <div className="hdv-form-default">
                
                <div className="row">
                    <div className="col-md-12">
                        <label className="required" htmlFor="supports_class_c" title="O dispositivo suporta Classe C">O dispositivo suporta Classe C</label>
                        <input
                            type='checkbox'
                            checked={detalhes.supports_class_c}
                            id="supports_class_c"
                            onChange={(e) => this.handleChange("supports_class_c", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-supports_class_c'>{ errors["supports_class_c"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="class_c_timeout" title="Tempo limite de downlink confirmado de Classe C (segundos)">Tempo limite de downlink confirmado de Classe C (segundos)</label>
                        <input
                            type='text'
                            value={detalhes.class_c_timeout ?? ""}
                            id="class_c_timeout"
                            disabled={!detalhes.supports_class_c || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("class_c_timeout", value)
                            }}
                        />
                        <span id='validacao-class_c_timeout'>{ errors["class_c_timeout"] ?? ""  }</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default ClassC